<template>
  <div>
    <div class="login-container" v-if="false">
      <el-form :model="loginValidateForm" ref="loginForm" class="login-form">
        <el-form-item class="title-tip">多比特投放分析平台</el-form-item>
        <el-form-item
          label
          prop="username"
          :rules="[
            { required: true, message: '请输入账号' },
            { type: 'string', message: '' },
          ]"
        >
          <el-input
            type="username"
            placeholder="账号"
            v-model.trim="loginValidateForm.username"
            autocomplete="on"
            suffix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item
          label
          prop="password"
          :rules="[
            { required: true, message: '请输入密码' },
            { type: 'string', message: '' },
          ]"
        >
          <el-input
            type="password"
            placeholder="密码"
            v-model.trim="loginValidateForm.password"
            autocomplete="on"
            suffix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item
          label
          prop="verifyCode"
          :rules="[
            { required: true, message: '亲! 请输入验证码' },
            { type: 'string', message: '' },
          ]"
        >
          <div class="code">
            <el-input
              type="verifyCode"
              placeholder="验证码"
              v-model.trim="loginValidateForm.verifyCode"
              autocomplete="on"
            ></el-input>
            <span>
              <img :src="imgUrl" @click="refreshImg" />
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')"
            >登录</el-button
          >
          <!-- <el-button @click="resetForm('numberValidateForm')">Reset</el-button>  -->
        </el-form-item>
      </el-form>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        flex-flow: column;
      "
    >
      <img :src="loadingurl" class="loadingicon" />
      <div style="margin-top: 40px">正在努力加载中...</div>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  name: "login",
  data() {
    return {
      loadingurl: require("./../../assets/loadingIcon.png"),
      loginValidateForm: {
        username: "",
        password: "",
        verifyCode: "",
      },
    };
  },
  created: function () {
    // localStorage.removeItem("TIME");
    // localStorage.removeItem("userInfo");
    // this.$store.dispatch("getVerifyCode");
    // localStorage.removeItem("route");
    this.CommonLogin();
  },
  computed: {
    // 计算属性的 getter
    imgUrl: function () {
      // `this` 指向 vm 实例
      return this.$store.state.login.imageUrl;
    },
  },
  methods: {
    CommonLogin() {
      this.$store.dispatch("ssologin", {
        cb: (data) => {
          console.log(data);
        },
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = { ...this.loginValidateForm };
          param.password = md5(param.password);
          this.$store.dispatch("getUserInfo", {
            param,
            cb: (param) => {
              this.$notify({
                title: "登录提示",
                message: param.msg,
                type: param.type,
              });
            },
          });
        } else {
          return false;
        }
      });
    },
    refreshImg() {
      this.$store.dispatch("getVerifyCode");
    },
  },
};
</script>

<style  lang="less" rel="stylesheet/less" scoped>
.login-container {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: url("../../assets/banner.jpg");
}
.login-form {
  width: 25%;
  min-width: 250px;
  background-color: rgba(0, 0, 0, 0.21);
  float: right;
  border-radius: 0px;
  padding: 6vh;
  border-radius: 20px;
  margin-right: 11%;
  margin-bottom: 9%;
}
.el-input__inner {
  background-color: rgba(0, 0, 0, 0.21);
}
.el-button {
  width: 100%;
}
.code {
  display: flex;
  span {
    display: inline-block;
    width: 130px;
    margin-left: 10px;
    line-height: 38px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    // background: #fff;
  }
  img {
    height: 30px;
    display: block;
    margin: 4px auto;
  }
}
.el-button--primary {
  background-color: #4c9a39;
  border-color: #4c9a39;
}
.loadingicon {
  width: 80px;
  height: 80px;
  animation: myfirst 1s linear infinite;
}
@keyframes myfirst {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style lang="less">
.login-form .el-input__inner {
  background-color: rgba(0, 0, 0, 0.21);
  .code span {
    background-color: rgba(0, 0, 0, 0.21);
  }
}
</style>